import { g as generateId } from './utils2.js';

const Api = ({ authToken, apiOrigin }) => {
    async function getAuthorizationHeader() {
        if (!authToken) {
            return {
                'Content-Type': 'application/json',
            };
        }
        return {
            Authorization: `Bearer ${authToken}`,
            'Idempotency-Key': generateId(),
            'Content-Type': 'application/json',
        };
    }
    async function makeRequest({ endpoint, method, params, body, signal, headers, }) {
        const url = `${apiOrigin}/v1/${endpoint}`;
        const requestUrl = params ? `${url}?${new URLSearchParams(params)}` : url;
        const defaultHeaders = await getAuthorizationHeader();
        const mergedHeaders = Object.assign(Object.assign({}, defaultHeaders), headers);
        const response = await fetch(requestUrl, {
            method: method,
            headers: mergedHeaders,
            body: body,
            signal: signal,
        });
        if (response) {
            return response.status === 204 ? {} : response.json();
        }
        handleError(requestUrl);
    }
    async function get({ endpoint, params, signal, headers, }) {
        return makeRequest({ endpoint, method: 'GET', params, signal, headers });
    }
    async function post({ endpoint, body, params, signal, headers, }) {
        return makeRequest({
            endpoint,
            method: 'POST',
            params,
            body: JSON.stringify(body),
            signal,
            headers,
        });
    }
    async function put({ endpoint, body, params, signal, }) {
        return makeRequest({
            endpoint,
            method: 'PUT',
            params,
            body: JSON.stringify(body),
            signal,
        });
    }
    async function patch({ endpoint, body, params, signal, }) {
        return makeRequest({
            endpoint,
            method: 'PATCH',
            params,
            body: JSON.stringify(body),
            signal,
        });
    }
    async function destroy({ endpoint, params, signal, }) {
        return makeRequest({ endpoint, method: 'DELETE', params, signal });
    }
    return { get, post, put, patch, destroy };
};
function handleError(requestUrl) {
    console.error(`Error fetching from ${requestUrl}`);
}

export { Api as A };
